module.exports = __webpack_public_path__ + "img/natural_oak_226m_detail_rsh.bf9c7739.jpg";